const paginationOptions = (instance) => ({
  pagination: {
    el: instance.paginationEl,
    type: "bullets",
    dynamicBullets: true,
    dynamicMainBullets: 15,
    hideOnClick: false,
    clickable: true,
  },
});

const navigationOptions = (instance) => ({
  navigation: {
    prevEl: instance.prevEl,
    nextEl: instance.nextEl,
    disabledClass: "is-disabled",
    hiddenClass: "is-hidden",
  },
});

const indexSliderOptions = (instance) => {
  instance.customNavTexts = [
    ...instance.querySelectorAll("[data-custom-nav-text]"),
  ].map((el) => el.dataset.customNavText);
  instance.isAnimatable = false;

  return {
    effect: "fade",
    followFinger: false,
    speed: 500,
    slidesPerView: 1,
    autoplay: {
      delay: 7000,
      disableOnInteraction: true,
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      0: { autoplay: false },
      1024: {
        autoplay: {
          delay: 7000,
          disableOnInteraction: true,
          pauseOnMouseEnter: true,
        },
      },
    },
    pagination: {
      el: document.querySelector(".js-index-banner-pagination"),
      bulletClass: "c-btn--pagination",
      bulletActiveClass: "is-active",
      renderBullet: function (index, className) {
        return `
                    <button class="c-btn ${className}" type="button" data-slide-index="${index}" data-name="${
          instance.customNavTexts[index]
        }">
                        ${instance.customNavTexts[index]}
                    </button>
                    <span class="is-divider ${
                      index === 0 && "is-near-active"
                    }">&nbsp;</span>
                `;
      },
    },
    on: {
      init(swiper) {
        requestAnimationFrame(() => {
          document
            .querySelectorAll(".js-index-banner-pagination .c-btn")
            .forEach((button) => {
              button.addEventListener("click", (event) => {
                swiper.slideTo(event.target.dataset.slideIndex);
              });
            });

          const indexBannerFakeLeft = document.querySelector(
            ".js-index-banner-fake-left"
          );
          const indexBannerFakeRight = document.querySelector(
            ".js-index-banner-fake-right"
          );

          if (indexBannerFakeLeft) {
            indexBannerFakeLeft.classList.toggle(
              "is-disabled",
              swiper.navigation.prevEl.classList.contains("is-disabled")
            );
            indexBannerFakeLeft.disabled =
              swiper.navigation.prevEl.classList.contains("is-disabled");
            indexBannerFakeLeft.addEventListener("click", (event) => {
              document.querySelector("[r-slider-index-banner]").prevEl.click();
            });
          }

          if (indexBannerFakeRight) {
            indexBannerFakeRight.classList.toggle(
              "is-disabled",
              swiper.navigation.nextEl.classList.contains("is-disabled")
            );
            indexBannerFakeRight.disabled =
              swiper.navigation.nextEl.classList.contains("is-disabled");
            indexBannerFakeRight.addEventListener("click", (event) => {
              document.querySelector("[r-slider-index-banner]").nextEl.click();
            });
          }
        });
      },
      slideChange(swiper) {
        if (!instance.isAnimatable) {
          swiper.slides.forEach((slide) =>
            slide.classList.add("is-animatable")
          );

          instance.isAnimatable = true;
        }

        const indexBannerFakeLeft = document.querySelector(
          ".js-index-banner-fake-left"
        );
        const indexBannerFakeRight = document.querySelector(
          ".js-index-banner-fake-right"
        );

        if (indexBannerFakeLeft) {
          indexBannerFakeLeft.classList.toggle(
            "is-disabled",
            swiper.navigation.prevEl.classList.contains("is-disabled")
          );
          indexBannerFakeLeft.disabled =
            swiper.navigation.prevEl.classList.contains("is-disabled");
        }

        if (indexBannerFakeRight) {
          indexBannerFakeRight.classList.toggle(
            "is-disabled",
            swiper.navigation.nextEl.classList.contains("is-disabled")
          );
          indexBannerFakeRight.disabled =
            swiper.navigation.nextEl.classList.contains("is-disabled");
        }

        const navWrapper = swiper.pagination.el;
        if (navWrapper) {
          const navWrapperInfo = navWrapper.getBoundingClientRect();
          const activeNavItem = navWrapper.querySelector(".c-btn.is-active");
          const activeNavItemInfo = activeNavItem.getBoundingClientRect();
          const dividers = navWrapper.querySelectorAll(".is-divider");

          const isLurkingOnLeftSide = activeNavItemInfo.x < navWrapperInfo.x;
          const isLurkingOnRightSide =
            activeNavItemInfo.x + activeNavItemInfo.width >
            navWrapperInfo.x + navWrapperInfo.width;

          if (isLurkingOnLeftSide || isLurkingOnRightSide) {
            navWrapper.scrollTo({
              left: activeNavItemInfo.x - navWrapperInfo.x,
              top: 0,
              behavior: "smooth",
            });
          }

          for (const divider of dividers) {
            divider.classList.remove("is-near-active");
          }

          if (
            activeNavItem.nextElementSibling &&
            activeNavItem.nextElementSibling.classList.contains("is-divider")
          ) {
            activeNavItem.nextElementSibling.classList.add("is-near-active");
          }

          if (
            activeNavItem.previousElementSibling &&
            activeNavItem.previousElementSibling.classList.contains(
              "is-divider"
            )
          ) {
            activeNavItem.previousElementSibling.classList.add(
              "is-near-active"
            );
          }
        }
      },
    },
  };
};

const indexProductSliderOptions = (instance) => {
  let productOptions = {
    loop: false,
    slidesPerView: "auto",
    slidesPerGroup: 1,
    spaceBetween: 0,
    cssMode: true,
    breakpoints: {
      1024: {
        cssMode: false,
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 16,
      },
      1200: {
        slidesPerView: 7,
        slidesPerGroup: 7,
        spaceBetween: 16,
      },
    },
    on: {},
  };

  return productOptions;
};

const productSliderOptions = (instance) => {
  let productOptions = {
    loop: false,
    slidesPerView: "auto",
    slidesPerGroup: 1,
    spaceBetween: 0,
    cssMode: true,
    breakpoints: {
      1024: {
        cssMode: false,
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 16,
      },
      1200: {
        slidesPerView: 5,
        slidesPerGroup: 5,
        spaceBetween: 16,
      },
    },
    on: {},
  };

  if (instance.pageCountEl) {
    productOptions.on.breakpoint = () => {
      requestAnimationFrame(() => {
        const template = instance.pageCountEl.dataset.template;
        const perPage = instance.swiper.slidesPerViewDynamic();
        const total = instance.swiper.slides.length;

        instance.pageCountEl.textContent = template
          .replace(":perPage", perPage)
          .replace(":total", total);
      });
    };
  }

  if (instance.classList.contains("is-description")) {
    productOptions.breakpoints = {
      1024: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 16,
      },
      1200: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 10,
      },
    };
  }

  if (instance.classList.contains("is-article-content")) {
    productOptions.breakpoints = {
      1024: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 15,
      },
    };

    productOptions.on = {
      afterInit: function (swiper) {
        if (!swiper.allowSlideNext && !swiper.allowSlidePrev) {
          swiper.$el[0].classList.add("wanna-be-centered");
        } else {
          swiper.$el[0].classList.remove("wanna-be-centered");
        }
      },
      resize: function (swiper) {
        if (!swiper.allowSlideNext && !swiper.allowSlidePrev) {
          swiper.$el[0].classList.add("wanna-be-centered");
        } else {
          swiper.$el[0].classList.remove("wanna-be-centered");
        }
      },
    };
  }

  return productOptions;
};

const indexContentSliderOptions = (instance) => {
  let indexContentSliderOptions = {
    loop: false,
    slidesPerView: "auto",
    slidesPerGroup: 1,
    spaceBetween: 0,
    cssMode: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: true,
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      768: {
        cssMode: false,
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
  };

  return indexContentSliderOptions;
};

const topProductsSliderOptions = (instance) => {
  let productOptions = {
    effect: "fade",
    loop: false,
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 0,
    autoplay: {
      delay: 2000,
      disableOnInteraction: true,
      pauseOnMouseEnter: true,
    },
  };

  return productOptions;
};

const footerBenefitsSliderOptions = (instance) => {
  let productOptions = {
    loop: false,
    slidesPerView: "auto",
    slidesPerGroup: 1,
    spaceBetween: 0,
    cssMode: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: true,
      pauseOnMouseEnter: true,
    },
  };

  return productOptions;
};

const options = (instance) => {
  // default options
  let options = {
    simulateTouch: false,
    watchOverflow: true,
    roundLengths: true,
  };

  if (instance.paginationEl) {
    options = { ...options, ...paginationOptions(instance) };
  }

  if (instance.prevEl && instance.nextEl) {
    options = { ...options, ...navigationOptions(instance) };
  }

  if (instance.hasAttribute("r-slider-index-banner")) {
    options = { ...options, ...indexSliderOptions(instance) };
  }

  if (instance.hasAttribute("r-slider-index-content-banner")) {
    options = { ...options, ...indexContentSliderOptions(instance) };
  }

  if (instance.hasAttribute("r-slider-index-products")) {
    options = { ...options, ...indexProductSliderOptions(instance) };
  }

  if (instance.hasAttribute("r-slider-products")) {
    options = { ...options, ...productSliderOptions(instance) };
  }

  if (instance.hasAttribute("r-slider-top-products")) {
    options = { ...options, ...topProductsSliderOptions(instance) };
  }

  if (instance.hasAttribute("r-slider-footer-benefits")) {
    options = { ...options, ...footerBenefitsSliderOptions(instance) };
  }

  return { ...options, ...instance.customOptions };
};

export default options;
